/**
 * @generated SignedSource<<5e7dbe9b53f62ffd9a3840daa0adbff5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WorkspaceRunnerPhase = "BINDING_VOLUME" | "PENDING" | "PREPARING_WORKSPACE" | "READY" | "SCHEDULING_POD" | "STARTING_POD";
import { Url } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRendererFragment$data = {
  readonly id: string;
  readonly phase: WorkspaceRunnerPhase;
  readonly url: Url;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspacePhaseProgressFragment">;
  readonly " $fragmentType": "WorkspaceRendererFragment";
};
export type WorkspaceRendererFragment$key = {
  readonly " $data"?: WorkspaceRendererFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRendererFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceRendererFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phase",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspacePhaseProgressFragment"
    }
  ],
  "type": "WorkspaceRunner",
  "abstractKey": null
};

(node as any).hash = "d867ae4b01465cb0df255fca4af100cc";

export default node;
